module.exports = __webpack_public_path__ + "img/mpg.647d9996.png";